// extracted by mini-css-extract-plugin
module.exports = {"ProgressBar":"TimeBar_ProgressBar__16Soy","Time":"TimeBar_Time__2FCQ3"};